<template>
  <v-flex xs12>
    <v-card>
      <v-card-title color="white" class="pb-0 mb-0">
        <v-container>
          <v-layout wrap>
            <v-flex md6>
              <h1>{{ $t('Conversaciones') }}</h1>
            </v-flex>
            <v-flex md6>
              <v-text-field
                v-model="search"
                solo
                color="primary"
                append-icon="mdi-magnify"
                :label="$t('Search')"
                @click:append="searchThread"
                single-line
                hide-details
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout align-center justify-end wrap row fill-height class="mt-1 pt-1 white--text">
            <v-flex xs12 md6 my-0 py-0>
              <category-select
                hide-details
                solo
                color="primary"
                v-model="categories"
              ></category-select>
            </v-flex>
            <v-flex xs12 md6 my-0 py-0 px-0>
              <div class="status-radio-div">
                <v-radio-group hide-details class="justify-content-end" v-model="status" row>
                  <v-radio color="success" :label="$t('Activas')" value="active"></v-radio>
                  <v-radio color="grey" :label="$t('Cerradas')" value="closed"></v-radio>
                  <v-radio color="primary" :label="$t('Todas')" value></v-radio>
                </v-radio-group>
              </div>
            </v-flex>
            <v-flex my-0 py-0 px-0>
              <v-switch v-model="unreadMessages" :label="'Mostrar mensajes sin leer'"></v-switch>
            </v-flex>
            <v-flex my-0 py-0 px-0>
              <v-switch
                class="right"
                v-model="unreadThreads"
                :label="'Mostrar marcadas como NO leídas'"
              ></v-switch>
            </v-flex>

            <!-- <div class="mx-3">
                            <v-checkbox  color="primary" :label="$t('Activas')" v-model="active"></v-checkbox>
                        </div>
                        <div class="mx-3">
                            <v-checkbox  color="primary" :label="$t('Cerradas')" v-model="closed"></v-checkbox>
            </div>-->
          </v-layout>
        </v-container>
      </v-card-title>
      <v-progress-linear
        v-if="loading"
        class="py-0 my-0"
        height="3"
        :indeterminate="loading"
      ></v-progress-linear>

      <v-list two-line>
        <template v-for="thread in threads">
          <v-list-tile
            :key="thread.id"
            avatar
            @click="threadDetail(thread.id)"
            v-bind:class="{ 'unread-thread': !thread.read_by_customer }"
          >
            <v-list-tile-avatar mr-2>
              <v-badge v-if="thread.unreaded_messages" size="24" color="secondary" overlap>
                <span slot="badge">{{ thread.unreaded_messages }}</span>
                <category-icon x-large :category="thread.category"></category-icon>
              </v-badge>
              <category-icon v-else x-large :category="thread.category"></category-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title v-html="thread.title"></v-list-tile-title>
              <v-list-tile-sub-title>
                <message-excerpt :message="lastComment(thread)"></message-excerpt>
              </v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action class="mr-3">
              <v-badge color="primary" overlap>
                <span slot="badge">{{ thread.messages_count }}</span>
                <v-icon color="grey">mdi-message-text</v-icon>
              </v-badge>
            </v-list-tile-action>
            <v-list-tile-action>
              <status-widget :status="thread.status"></status-widget>
            </v-list-tile-action>
            <v-list-tile-action>
              <v-btn icon flat>
                <v-icon color="primary">mdi-chevron-right</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>
          <v-divider :key="'div-' + thread.id"></v-divider>
        </template>
      </v-list>
      <div class="text-xs-center">
        <v-pagination v-model="page" :length="pagination.last_page"></v-pagination>
      </div>
    </v-card>
  </v-flex>
</template>

<script>
import axios from 'axios';
import CategoryIcon from '@/components/commons//CategoryIcon.vue';
import StatusWidget from '@/components/commons//StatusWidget.vue';
import ThreadAPI from '../../services/thread.js';
import MessageExcerpt from '@/components/commons//MessageExcerpt.vue';
import CategorySelect from '@/components/commons//CategorySelect.vue';
export default {
  components: {
    CategoryIcon,
    StatusWidget,
    MessageExcerpt,
    CategorySelect,
  },
  data() {
    return {
      page: 1,
      search: '',
      status: '',
      categories: [],
      threads: [],
      loading: true,
      params: {
        search: {
          search: '',
        },
        status: '',
        unreadMessages: false,
        unreadByCustomer: false,
        categories: null,
        page: 1,
        where: {},
      },
      unreadMessages: false,
      unreadThreads: false,

      pagination: {
        current_page: 1,
        from: 1,
        last_page: null,
        per_page: 15,
        to: null,
        total: null,
      },
    };
  },
  created() {
    this.searchRequestId = 0;
    this.searchScheduled = false;
    this.cancelSearch = null;
  },
  mounted() {
    this.searchThread();
  },
  methods: {
    searchThread: function() {
      // Los cambios de filtro que llegan juntos (p. ej. «Restaurar filtros») lanzan una sola petición
      if (this.searchScheduled) {
        return;
      }
      this.searchScheduled = true;
      this.$nextTick(() => {
        this.searchScheduled = false;
        this.fetchThreads();
      });
    },
    fetchThreads: function() {
      // Solo vale la respuesta de la última petición: las anteriores se cancelan y, si llegan, se descartan
      if (this.cancelSearch) {
        this.cancelSearch();
      }
      const requestId = ++this.searchRequestId;
      this.loading = true;
      const cancelToken = new axios.CancelToken(cancel => {
        this.cancelSearch = cancel;
      });
      ThreadAPI.getThreadSearchPaginate(this.params, { cancelToken })
        .then(response => {
          if (requestId !== this.searchRequestId) {
            return;
          }
          this.threads = response.data.data;
          this.pagination = response.data.meta;
        })
        .catch(() => {})
        .then(() => {
          if (requestId === this.searchRequestId) {
            this.loading = false;
          }
        });
    },

    threadDetail: function(thread) {
      this.$router.push({ name: 'threadDetail', params: { thread: thread } });
      // console.log('clicked');
    },
    lastComment: function(thread) {
      return thread.last_message;
    },
    searchIfStop: function(val) {
      if (val === this.search) {
        this.page = 1;
        this.searchThread();
      }
    },
  },
  watch: {
    categories: function(val, oldVal) {
      console.log(val);
      this.params.categories = val;
      this.page = 1;
      this.searchThread();
    },
    status: function(val, oldVal) {
      console.log(val);
      this.params.status = val;
      this.page = 1;
      this.searchThread();
    },
    search: function(val, oldVal) {
      this.params.search.search = val;
      if (val.length > 3 || oldVal.length > val.length) {
        // console.log(val);
        const component = this;
        setTimeout(() => {
          component.searchIfStop(val);
        }, 500);
      }
    },
    page: function(val, oldVal) {
      this.params.page = val;
      // console.log(val);

      this.searchThread();
    },
    unreadMessages: function(val, oldVal) {
      console.log(val);
      this.params.unreadMessages = val;
      this.page = 1;
      this.searchThread();
    },
    unreadThreads: function(val, oldVal) {
      this.params.unreadByCustomer = val;
      this.page = 1;
      this.searchThread();
    },
  },
};
</script>

<style scoped>
.og-select-category {
  max-width: 500px;
}
.status-radio-div {
  float: right;
}
.unread-thread {
  background-color: #ffffe0;
}
</style>
